import { useLocation } from 'react-router';

import { useGetPointsOfSalesQuery } from '~entities/pos';

import { ROUTES } from '~shared/config/routes';

import IconDashboard from '../icons/dashboard.svg?react';
import IconOrders from '../icons/orders.svg?react';
import IconReports from '../icons/reports.svg?react';
import { NavItemProps } from '../types';

export const useNavigationItems = () => {
  const { pathname } = useLocation();
  const { data: posList } = useGetPointsOfSalesQuery();
  const hasOnlineStores = posList?.some((pos) => pos.type === 'ONLINE');

  const navItems: NavItemProps[] = [
    {
      to: ROUTES.dashboard,
      label: 'Dashboard',
      icon: IconDashboard,
    },
  ];

  if (hasOnlineStores) {
    navItems.push({
      to: ROUTES.orders.root,
      label: 'Orders',
      icon: IconOrders,
    });
  }

  navItems.push({
    to: pathname.startsWith(ROUTES.transactions.root)
      ? pathname
      : ROUTES.transactions.root,
    label: 'Reports',
    icon: IconReports,
  });

  return navItems;
};
